export const PRODUCT_COLORS = [
  { name: "Pearl White", hex: "#E8E8E8", surface: "rgba(232,232,232,0.08)", id: "white" },
  { name: "Rose Quartz", hex: "#FFD1DC", surface: "rgba(255,209,220,0.08)", id: "pink" },
  { name: "Jade Mist", hex: "#A1E5B5", surface: "rgba(161,229,181,0.08)", id: "green" },
  { name: "Electric Cyan", hex: "#22D3EE", surface: "rgba(34,211,238,0.08)", id: "blue" },
  { name: "Phantom Black", hex: "#1A1A1A", surface: "rgba(255,255,255,0.04)", id: "black" },
];

export const PRODUCT_IMAGES = [
  {
    url: "https://images.unsplash.com/photo-1657537488218-f7eb744c5b0b?w=800&q=80",
    thumb: "https://images.unsplash.com/photo-1657537488218-f7eb744c5b0b?w=200&q=60",
    label: "Product",
    alt: "breeze° bladeless neck fan — front view",
  },
  {
    url: "https://images.unsplash.com/photo-1707167144744-96723112e356?w=800&q=80",
    thumb: "https://images.unsplash.com/photo-1707167144744-96723112e356?w=200&q=60",
    label: "USB-C Detail",
    alt: "Close-up of USB-C charging port",
  },
  {
    url: "https://images.unsplash.com/photo-1635085421227-6d6d1532f149?w=800&q=80",
    thumb: "https://images.unsplash.com/photo-1635085421227-6d6d1532f149?w=200&q=60",
    label: "Lifestyle",
    alt: "Feel the breeze — lifestyle shot",
  },
  {
    url: "https://images.pexels.com/photos/29854260/pexels-photo-29854260.jpeg?auto=compress&cs=tinysrgb&w=800",
    thumb: "https://images.pexels.com/photos/29854260/pexels-photo-29854260.jpeg?auto=compress&cs=tinysrgb&w=200",
    label: "In Use",
    alt: "Woman using portable fan outdoors",
  },
];

export const SPECS = [
  { label: "Battery", value: "1500mAh", detail: "Up to 6hrs runtime" },
  { label: "Weight", value: "0.4kg", detail: "Ultra-lightweight" },
  { label: "Speeds", value: "5 Modes", detail: "Whisper to turbo" },
  { label: "Material", value: "ABS+", detail: "Premium grade" },
];

export const REVIEWS = [
  { name: "Sarah M.", rating: 5, text: "Game changer for summer commutes. So light I forget I'm wearing it.", verified: true, date: "3 days ago" },
  { name: "James K.", rating: 5, text: "Bought the blue one — the bladeless design is genius. No hair catching.", verified: true, date: "1 week ago" },
  { name: "Priya R.", rating: 4, text: "Great airflow on speed 3. Battery lasts my entire shift outdoors.", verified: true, date: "2 weeks ago" },
  { name: "Mike T.", rating: 5, text: "Bought for the whole family. The kids love the different colors.", verified: true, date: "3 weeks ago" },
  { name: "Lisa C.", rating: 5, text: "Finally a neck fan that doesn't look ridiculous. Sleek and powerful.", verified: true, date: "1 month ago" },
  { name: "David W.", rating: 5, text: "USB-C charging is a huge plus. Works with my phone charger.", verified: true, date: "1 month ago" },
];

export const FAQ_ITEMS = [
  { q: "Is it safe without blades?", a: "Absolutely. The bladeless design uses a turbine-driven airflow system that's completely safe — no exposed moving parts near your skin or hair." },
  { q: "How long does the battery last?", a: "The 1500mAh battery provides 2-6 hours of cooling depending on speed. A full charge takes about 2 hours via USB-C." },
  { q: "Will it fit all neck sizes?", a: "The flexible silicone band adjusts to fit comfortably. The 225mm opening accommodates virtually all neck sizes." },
  { q: "How loud is it?", a: "On speeds 1-3, it's virtually silent (under 25dB). Even on turbo mode, it stays under conversation level." },
  { q: "What's the return policy?", a: "We offer a no-questions-asked 30-day money-back guarantee. If you're not completely satisfied, we'll refund your purchase in full." },
];

export const USE_CASES = [
  { title: "Outdoor Workouts", desc: "Stay cool while staying active" },
  { title: "Office & WFH", desc: "Silent cooling at your desk" },
  { title: "Festivals & Events", desc: "Beat the heat in any crowd" },
  { title: "Travel & Commute", desc: "Compact enough for carry-on" },
  { title: "Kitchen Cooking", desc: "Hands-free relief over the stove" },
  { title: "Walks & Hikes", desc: "Nature without the sweat" },
];

export const PRICE = 24.96;
export const COMPARE_PRICE = 39.99;
export const DISCOUNT_PERCENT = 37;
